import React, { FC, Fragment } from 'react';
import { Container } from '@src/components/Container';
import { SilentDialog } from '@src/components/SilentDialog';
import ProgressBar from '@src/components/ProgressBar';
import FrCheckBlueSvg from '@src/svgs/fr-check-blue.svg';
import { CYCLE_LABELS } from '@src/constants';
import { ContainerType } from '@src/components/Container/enums/containerType.enum';
import { SubscriptionPlansContainerProps } from './props';
import './styles.scss';

const PALETTE = {
  '0-100': 'subscription-plans__progressbar-blue',
};

export const SubscriptionPlansContainer: FC<SubscriptionPlansContainerProps> = ({
  title,
  subtitle,
  descriptionText,
  footerInfo,
  subscriptionPrice,
  slotPrice,
  discountedSlotPrice,
  subscriptionCycle,
  benefits,
  activeOpenings,
  buttons,
  footer,
  totalPrice,
  openingActivationPrice,
  currencySymbol,
}) => {
  return (
    <Container className="subscription-plans" type={ContainerType.BORDERED}>
      <div className="subscription-plans__title">{title}</div>

      <div className="subscription-plans__subtitle">{subtitle}</div>

      {typeof subscriptionPrice === 'number' && !!subscriptionCycle && !!currencySymbol && (
        <div className="subscription-plans__price">
          {subscriptionPrice === 0 ? (
            <span className="subscription-plans__price-value">Free</span>
          ) : (
            <>
              <span className="subscription-plans__price-value">
                {currencySymbol}
                {subscriptionPrice}
              </span>
              <span className="subscription-plans__price-period">{CYCLE_LABELS[subscriptionCycle]}</span>
            </>
          )}
        </div>
      )}

      {!!openingActivationPrice && (
        <div className="subscription-plans__activation-price">
          <span className="subscription-plans__activation-price-value">
            + {currencySymbol}
            {openingActivationPrice}
          </span>
          <span className="subscription-plans__activation-price-period">/mo</span>
          <span className="subscription-plans__activation-price-info"> per extra opening*</span>
        </div>
      )}

      {slotPrice && (
        <div>
          <span className="subscription-plans__slot-amount">+ {slotPrice}</span>
          <span className="subscription-plans__slot-info"> each additional slot</span>
        </div>
      )}

      {discountedSlotPrice && (
        <div>
          <span className="subscription-plans__slot-amount">+ {discountedSlotPrice}</span>
          <span className="subscription-plans__slot-info"> each additional slot</span>
        </div>
      )}

      {activeOpenings && activeOpenings.amount && activeOpenings.slots && (
        <ProgressBar
          className="subscription-plans__active-openings"
          maxValue={activeOpenings.slots}
          palette={PALETTE}
          thickness="medium"
          value={activeOpenings.amount}
        >
          <div className="subscription-plans__progres-info">
            {`Using ${activeOpenings.amount} of ${activeOpenings.slots} slots`}
          </div>
        </ProgressBar>
      )}

      {!!descriptionText && <div className="subscription-plans__description-text">{descriptionText}</div>}

      {!!benefits &&
        benefits.map((text, index) => (
          <SilentDialog className="subscription-plans__item" icon={FrCheckBlueSvg} key={index} text={text} />
        ))}

      {!!buttons && <div className="subscription-plans__buttons">{buttons}</div>}

      {!!openingActivationPrice && (
        <Fragment>
          <div className="subscription-plans__divider" />
          <div className="subscription-plans__footer-info">
            *Extra openings are billed in a 30-day cycle starting from the publishing date.{' '}
            <a href="https://meetfrank.com/business/pricing" target="_blank" rel="noreferrer">
              Learn more about pricing.
            </a>
          </div>
        </Fragment>
      )}

      {!!footer || !!footerInfo ? <div className="subscription-plans__divider" /> : null}

      {!!footer && <div className="subscription-plans__footer">{footer}</div>}

      {!!totalPrice && (
        <div className="subscription-plans__footer">
          <div className="subscription-plans__total-price-label">Total</div>
          <div className="subscription-plans__total-price-value">
            {' '}
            {currencySymbol}
            {totalPrice}
          </div>
        </div>
      )}

      {!!footerInfo && <div className="subscription-plans__footer-info">{footerInfo}</div>}
    </Container>
  );
};
